import { render, staticRenderFns } from "./PaymentIssuerStatus.vue?vue&type=template&id=5a734fdc&scoped=true"
import script from "./PaymentIssuerStatus.vue?vue&type=script&lang=js"
export * from "./PaymentIssuerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a734fdc",
  null
  
)

export default component.exports